/*
 *  Author: DL
 *  Date: 2020-12-04 14:51:01
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-18 17:57:55
 *  LastEditors: DL
 *  Description: 单/多楼层切换控件
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useContext, useCallback } from 'react';
import { Button, Icon } from 'ui';
import Control from '@/components/Control';
import Context from '@/hook/useFmapContext';

export default () => {
    const { fmap, visibleModel } = useContext(Context);

    const handleChangeLaryerMode = useCallback(() => {
        fmap.changeLaryerMode(visibleModel === 'single' ? 'multi' : 'single');
    }, [fmap, visibleModel]);

    return (
        <Control>
            <Button onClick={handleChangeLaryerMode}>
                <Icon className={`${visibleModel === 'single' ? 'iconduolouceng2' : 'iconlc'}`} />
            </Button>
        </Control>
    );
};
